import { render, staticRenderFns } from "./vFormPROJECT_SWITCH.vue?vue&type=template&id=60536e28&scoped=true&"
import script from "./vFormPROJECT_SWITCH.vue?vue&type=script&lang=js&"
export * from "./vFormPROJECT_SWITCH.vue?vue&type=script&lang=js&"
import style0 from "./vFormPROJECT_SWITCH.vue?vue&type=style&index=0&id=60536e28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60536e28",
  null
  
)

export default component.exports